export enum FsContactAttachmentStatusEnum {
  Uploading = 1,
  Processing = 2,
  ReadyForReview = 3,
  Failed = 4
}
